/**
 * Padrão visual dos modais (referência: Nova promoção).
 * Overlay esbranquiçado, painel com raio e sombra, título maior, X na mesma linha.
 */
export const MODAL_OVERLAY_CLASS =
  "gs-modal-overlay fixed inset-0 z-50 flex items-center justify-center bg-[#F4F6F8]/95 p-4";

/** Altura máxima do painel de modal (viewport menos margem superior/inferior). */
export const MODAL_PANEL_MAX_HEIGHT_CLASS = "gs-modal-panel-max max-h-[calc(100vh-48px)]";

/** No mobile, o rodapé permanece visível enquanto o conteúdo rola. */
export const MODAL_FOOTER_STICKY_MOBILE_CLASS =
  "max-sm:sticky max-sm:bottom-0 max-sm:z-[1] max-sm:-mx-6 max-sm:bg-white max-sm:px-6";

export const MODAL_PANEL_CLASS =
  "!rounded-xl border border-gray-200 bg-white text-gray-900 shadow-xl";

export const MODAL_HEADER_ROW_CLASS =
  "flex shrink-0 items-center justify-between gap-2 border-b border-gray-200 bg-white px-6 py-4";

export const MODAL_TITLE_CLASS = "text-xl font-semibold tracking-tight text-gray-900";

/** Título principal de página/aba (referência: aba Produtos). */
export const PAGE_TITLE_CLASS =
  "min-w-0 flex-1 truncate text-xl font-bold text-foreground";

/** Título principal fora de barra flex (páginas standalone). */
export const PAGE_TITLE_STANDALONE_CLASS =
  "min-w-0 truncate text-xl font-bold text-foreground";

/** Fundo do `<thead>` (referência: Financeiro > Despesas). */
export const TABLE_HEAD_CLASS = "bg-muted/50";

/** Tipografia padrão de `<th>` (referência: Financeiro > Despesas). */
export const TABLE_TH_CLASS = "text-sm font-semibold align-middle";

/** Área de conteúdo abaixo do header (mesmo padding do modal Nova promoção). */
export const MODAL_BODY_CLASS = "space-y-4 bg-white p-6 pt-4 text-gray-900";

/** Linha tracejada acima do rodapé — largura total do painel (alinhada à borda do título). */
export const MODAL_FOOTER_DIVIDER_CLASS =
  "-mx-6 border-t border-dashed border-gray-300";

/** Espaço simétrico entre último campo, linha tracejada e botão (cancela gap do space-y-4). */
export const MODAL_FOOTER_WRAPPER_CLASS = "-mt-4 pt-6";

/** Área do botão principal abaixo da linha tracejada. */
export const MODAL_FOOTER_ACTIONS_CLASS = "flex pt-6";
